"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var tasks_1 = require("../shared/tasks");
var GlobalBehaviors_1 = require("../shared/internal/GlobalBehaviors");
function init() {
    var globalBehaviors = (0, GlobalBehaviors_1.initGlobalBehaviors)();
    globalBehaviors.register(new tasks_1.EscapeTask());
    globalBehaviors.register(new tasks_1.DocumentScrollDisableTask());
}
exports.init = init;
//# sourceMappingURL=interface.js.map